import TextField from "@mui/material/TextField";

export const InputNumberHours = ({
  hours,
  setHours,
  className,
  disabled,
  autoFocus,
  ...props
}) => {
  const handleChange = (val: number) => {
    if (val > 24 || val < 0) {
      setHours("");
      return;
    }
    let decimals = val.toString().split(".")[1];
    if (!decimals || decimals.length < 3) {
      val === 0 ? setHours("") : setHours(val);
    }
  };

  return (
    <TextField
      autoFocus={autoFocus}
      className={className}
      type="number"
      value={hours}
      lang="en-EN"
      onWheel={(e) => {
        e.preventDefault();
        const input = e.target as HTMLInputElement;
        const currentValue = Number(input.value) || 0;
        handleChange(e.deltaY < 0 ? currentValue + 0.25 : currentValue - 0.25);
      }}
      slotProps={{
        input: {
          inputProps: {
            min: 0,
            max: 24,
            step: 0.25,
            defaultValue: "",
          },
        },
      }}
      onChange={(event: any) => {
        handleChange(Number(event?.target.value));
      }}
      disabled={disabled}
      {...props}
    />
  );
};
